import moment from 'moment';

export const daysRemainingTrialPlan = (subscription) => {
  const { trialEnd } = subscription || {};

  if (!trialEnd || moment.unix(trialEnd) < moment()) return null;

  const days = moment.unix(subscription.trialEnd).diff(moment(), 'days', true);
  const remaining = Math.ceil(Math.abs(days));

  return remaining;
};
